export default __webpack_public_path__ + "static/media/free-fun-bees.f97d963b.webp";